
// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import BookForm from "../../components/dashboard/BookForm";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <BookForm />
    </DashboardLayout>
  );
}
